// Define mixin
const is2020mixin = {
    methods: {
        /**
         * SECTION - Add comma to numbers
         * eg. 10000 -> 10,000
         */
        checkIs2021() {

            // create Date object for current location
            var date = new Date();

            // convert to milliseconds, add local time zone offset and get UTC time in milliseconds
            var utcTime = date.getTime() + (date.getTimezoneOffset() * 60000);

            // time offset for New Zealand is +12
            var timeOffset = 1;

            // create new Date object for a different timezone using supplied its GMT offset.
            var year = new Date(utcTime + (3600000 * timeOffset)).getFullYear();

            // FIXME - Bypass
            // return true;
            // var year = new Date().getFullYear();
            if (year > 2020) {
                return true;
            }
            return false;
        },
    },
};

// Export
export default is2020mixin;
